import React from "react"
import PropTypes from "prop-types"

import Tag from './Tag'

class TopicTags extends React.Component {
  constructor(props) {
    super(props)

    this.renderTags = this.renderTags.bind(this)
  }

  renderTags() {
    let tags = this.props.tags.map((tag, index) => {
      return (<Tag tag={tag} key={index} selected={this.props.selectedTags.includes(tag.id)} onClick={this.props.updateSelectedTags} />)
    })
    return tags
  }

  render() {
    return(
      <div style={{
        display: 'flex',
        maxWidth: 350,
        margin: 'auto',
        flexWrap: 'wrap',
        justifyContent: 'center'
      }}>
        {this.renderTags()}
      </div>
    )
  }

}

export default TopicTags;
